export default "__VITE_ASSET__B7j7pJxe__"